import React from 'react';
import { Chip } from '@heroui/react';
import ChangelogItem from './ChangelogItem.js';

// Parse a backend `YYYY-MM-DD` date-only string as a LOCAL calendar date.
// `new Date('YYYY-MM-DD')` parses as UTC midnight, which renders the previous
// calendar day in negative-offset timezones.
const parseLocalDate = value => {
	const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
	return new Date(year, month - 1, day);
};

function ReleaseSection({ release, isNew, isLast }) {
	const shortDate = release.date
		? parseLocalDate(release.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
		: '';

	return (
		<div style={{ display: 'flex', gap: '16px' }}>
			{/* Timeline — date instead of dot */}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					width: '48px',
					flexShrink: 0
				}}
			>
				<div
					style={{
						fontSize: '11px',
						fontWeight: 600,
						textAlign: 'center',
						lineHeight: 1.2,
						marginTop: '4px',
						color: isNew ? 'hsl(var(--heroui-primary))' : 'hsl(var(--heroui-default-400))'
					}}
				>
					{shortDate}
				</div>
				{!isLast && (
					<div
						style={{
							width: '1px',
							flex: 1,
							backgroundColor: 'hsl(var(--heroui-default-200))',
							marginTop: '8px'
						}}
					/>
				)}
			</div>

			{/* Content */}
			<div style={{ flex: 1, paddingBottom: isLast ? 0 : '32px' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
					{/* Use a div (not an <h3>) with role/aria-level for the release
					    title: the host layout forces `[role="dialog"] h3 { font-size:
					    inherit !important }` to tame Bootstrap, which would otherwise
					    shrink this heading below the item titles. A non-heading tag
					    keeps our inline size while preserving accessibility. */}
					<div
						role="heading"
						aria-level={3}
						style={{
							fontSize: '20px',
							fontWeight: 700,
							color: 'hsl(var(--heroui-default-900))',
							margin: 0
						}}
					>
						{release.title ?? `v${release.version}`}
					</div>
					<Chip size="sm" variant="flat" color="default" className="h-5 text-xs">
						v{release.version}
					</Chip>
					{isNew && (
						<Chip size="sm" variant="dot" color="primary" className="h-5 text-xs">
							New
						</Chip>
					)}
				</div>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
					{(release.items ?? []).map(item => (
						<ChangelogItem key={item.id} item={item} isNew={isNew} />
					))}
				</div>
			</div>
		</div>
	);
}

export default ReleaseSection;
